<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col align="center" justify="center" v-for="item in items" :key="item.title">
          <v-hover
            v-slot:default="{ hover }"
            >
            <v-card 
                height="300" 
                class="ml-10 mr-10"
                :elevation="hover ? 16 : 2">
              <v-icon x-large class="pt-7">{{item.icon}}</v-icon>
              <v-list-item-title class="headline pt-4" v-text="$t(`servicios[`+item.id+`].titulo`)"></v-list-item-title>
              <v-card-text v-text="$t(`servicios[`+item.id+`].descripcion`)">               
              </v-card-text>
              <v-btn v-if="item.id===0" class="align-center white--text" small color="#E8175D" @click="redirect()">Agendar Ahora!</v-btn>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  data() {
    return {
      items: [
        {
          id: 0,
          icon: "mdi-camera-enhance",
        },
        {
          id: 1,
          icon: "mdi-call-merge",
        },
        {
          id: 2,
          icon: "mdi-account-group",
        }
      ]
    };
  },
  methods:{
    redirect(){
      window.open('https://evascopes.com/campamento-astronomico/');
    }
  },
  props:[
    'titulo'
  ],
  components: {
    
  }
};
</script>

<style scoped>
    .v-icon{
        color: darkgrey;
    }
    .v-card .v-icon:hover{
        color: rgb(232, 23, 93);
    }
</style>>

</style>